import Form, { FormProviderProps } from "@/shared/form/form";
import { DYNAMIC_PROCESS_FORM } from "./forms-enum";
import { FieldsType } from "../../model/types";
import { NotificationTemplateInput } from "gql/graphql";
import { useSaveDynamicProcessModel } from "../../model/use-save-dynamic-process-model";
import { useNotification } from "@/shared/feedback/notification";
import { useTranslations } from "use-intl";
import { toProcessRouteStepInput } from "@/shared/form/process-route-step-input";
import { routeHasIncompleteSteps } from "@/shared/form/process-route-step-input";

export function DynamicProcessFormProvider({
  children,
  ...rest
}: FormProviderProps) {
  const { save } = useSaveDynamicProcessModel();
  const notify = useNotification();
  const tc = useTranslations("Common");

  return (
    <Form.Provider
      onFormFinish={async (name, info) => {
        try {
          for (const form of Object.values(info.forms)) {
            await form.validateFields();
          }
        } catch (e) {
          console.error(e);
          return;
        }

        if (name !== DYNAMIC_PROCESS_FORM.TRIGGER) {
          return;
        }

        const baseFormValues = info.forms[
          DYNAMIC_PROCESS_FORM.MODEL
        ].getFieldsValue() as FieldsType;

        const pathFormValues = info.forms[
          DYNAMIC_PROCESS_FORM.PATH
        ].getFieldsValue() as FieldsType;

        const approverNotificationTemplate = info.forms[
          DYNAMIC_PROCESS_FORM.APPROVER
        ].getFieldsValue() as NotificationTemplateInput;

        const initiatorNotificationTemplate = info.forms[
          DYNAMIC_PROCESS_FORM.INITIATOR
        ].getFieldsValue() as NotificationTemplateInput;

        // Шаг без персоны и без роли — это шаг со скрытым участником: тип шага
        // не восстановился, обязательные поля не смонтировались, валидация его
        // пропустила. Сохранение стёрло бы участника из маршрута.
        if (routeHasIncompleteSteps(pathFormValues.route ?? [])) {
          notify?.error({
            message: tc("HIDDEN_FIELDS_BLOCK_SAVE"),
          });
          return;
        }

        await save({
          ...baseFormValues,
          route: (pathFormValues.route ?? []).map(toProcessRouteStepInput),
          approverNotificationTemplate,
          initiatorNotificationTemplate,
        });
      }}
      {...rest}
    >
      {children}
    </Form.Provider>
  );
}
